import { motion } from "framer-motion";

const CallToAction = () => {
  return (
    <motion.div
      className="call-to-action-container-smco"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={{
        visible: { transition: { staggerChildren: 0.2 } },
      }}
    >
      {/* Left Section */}
      <motion.p
        className="call-to-action-text-smco"
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
        }}
      >
        We are here to help your business. Call to discuss your solution.
      </motion.p>

      {/* Divider */}
      <motion.div
        className="call-to-action-divider-smco"
        variants={{
          hidden: { opacity: 0, scaleX: 0 },
          visible: { opacity: 1, scaleX: 1, transition: { duration: 0.5 } },
        }}
      ></motion.div>

      {/* Right Section (Phone) */}
      <motion.div
        className="call-to-action-phone-container-smco"
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
        }}
      >
        <motion.div
          className="call-to-action-icon-wrapper-smco"
          variants={{
            hidden: { opacity: 0, scale: 0.5 },
            visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
          }}
        >
          <i className="fa-solid fa-phone-volume"></i>
        </motion.div>
        <motion.span
          className="call-to-action-phone-smco"
          variants={{
            hidden: { opacity: 0, x: -10 },
            visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
          }}
        >
          +91 7506550715
        </motion.span>
      </motion.div>
    </motion.div>
  );
};

export default CallToAction;
